"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    promoBannerVariants: ()=>promoBannerVariants,
    promoBannerPalettes: ()=>promoBannerPalettes,
    promoBannerEmphases: ()=>promoBannerEmphases
});
const index_cjs_namespaceObject = require("../../variants/index.cjs");
const promoBannerVariants = (0, index_cjs_namespaceObject.tv)({
    slots: {
        baseSlot: '@container flex h-full w-full overflow-hidden rounded-lg transition hover:cursor-pointer',
        mediaContainerSlot: '@2xl:w-28 flex w-20 items-center justify-center',
        mainContentandCTAContainerSlot: '@2xl:flex-row @2xl:p-4 flex-grow-1 flex flex-col gap-x-3 gap-y-2 p-3',
        mainContentContainerSlot: 'flex-grow-1 flex flex-col gap-1',
        ctaContainerSlot: 'flex flex-row items-center justify-end gap-2'
    },
    variants: {
        palette: {
            neutral: {},
            marketingBrand: {},
            promoPrimary: {},
            highlight: {}
        },
        emphasis: {
            regular: {},
            medium: {},
            bold: {}
        }
    },
    compoundVariants: [
        {
            palette: 'neutral',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-neutral-1 text-neutral-13 shadow-md hover:shadow-xl'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-neutral-3 text-neutral-13 hover:bg-neutral-4'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-neutral-12 text-neutral-1 hover:bg-neutral-11'
            }
        },
        {
            palette: 'marketingBrand',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-marketingBrand-1 text-marketingBrand-13 shadow-md hover:shadow-xl'
            }
        },
        {
            palette: 'marketingBrand',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-marketingBrand-3 text-marketingBrand-13 hover:bg-marketingBrand-4'
            }
        },
        {
            palette: 'marketingBrand',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-marketingBrand-12 text-marketingBrand-1 hover:bg-marketingBrand-13'
            }
        },
        {
            palette: 'promoPrimary',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-promoPrimary-1 text-promoPrimary-13 shadow-md hover:shadow-xl'
            }
        },
        {
            palette: 'promoPrimary',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-promoPrimary-3 text-promoPrimary-13 hover:bg-promoPrimary-4'
            }
        },
        {
            palette: 'promoPrimary',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-promoPrimary-12 text-promoPrimary-1 hover:bg-promoPrimary-13'
            }
        },
        {
            palette: 'highlight',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-highlight-1 text-highlight-13 shadow-md hover:shadow-xl'
            }
        },
        {
            palette: 'highlight',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-highlight-3 text-highlight-13 hover:bg-highlight-4'
            }
        },
        {
            palette: 'highlight',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-highlight-12 text-highlight-1 hover:bg-highlight-11'
            }
        }
    ],
    defaultVariants: {
        palette: 'neutral',
        emphasis: 'regular'
    }
});
const promoBannerPalettes = Object.keys(promoBannerVariants.variants.palette);
const promoBannerEmphases = Object.keys(promoBannerVariants.variants.emphasis);
exports.promoBannerEmphases = __webpack_exports__.promoBannerEmphases;
exports.promoBannerPalettes = __webpack_exports__.promoBannerPalettes;
exports.promoBannerVariants = __webpack_exports__.promoBannerVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "promoBannerEmphases",
    "promoBannerPalettes",
    "promoBannerVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
